import { AccessTimeOutlined, AssignmentOutlined, CheckCircleOutline, QuizOutlined } from "@mui/icons-material";
import { Box, Button, Card, CardContent, Chip, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

function ResultCard({ report }) {
  const submitted = report.status === "Submitted";
  const navigate = useNavigate();
  const percentage =
    report.totalPoints > 0
      ? Math.round((report.score / report.totalPoints) * 100)
      : 0;

  const handleViewResult = () => {
    navigate(`/assessment/result/${report.submissionId}`);
  };

  return (
    <Card className="result-card">
      <CardContent>
        <Box className="result-card-header">
          <Box className="result-icon">
            {report.type === "Exam" ? <QuizOutlined /> : <AssignmentOutlined />}
          </Box>

          <Box>
            <Typography className="result-title">{report.title}</Typography>

            <Typography className="result-type">{report.type}</Typography>
          </Box>
        </Box>

        <Box className="result-score">
          <Typography className="score">
            {submitted ? report.score : "—"}
          </Typography>

          <Typography className="total">/ {report.totalPoints}</Typography>
        </Box>

        {submitted && (
          <Typography className="percentage">{percentage}%</Typography>
        )}

        <Box className="result-status">
          <Chip
            icon={submitted ? <CheckCircleOutline /> : <AccessTimeOutlined />}
            label={submitted ? "Submitted" : "Not Submitted"}
            color={submitted ? "success" : "warning"}
            variant="outlined"
          />
        </Box>

        <Button variant="contained" onClick={handleViewResult} sx={{ mt: 2 }} disabled={!submitted}>
          View Result
        </Button>
      </CardContent>
    </Card>
  );
}

export default ResultCard;